import type { ReactNode } from 'react';
import { Icon } from '../icons';
import type { EventType } from '../../lib/types';

interface Props {
  value: EventType | null;
  onChange: (e: EventType) => void;
  onNext: () => void;
  onBack: () => void;
}

interface EventOption {
  id: EventType;
  title: string;
  sub: string;
  icon: ReactNode;
}

export function EventScreen({ value, onChange, onNext, onBack }: Props) {
  const events: EventOption[] = [
    { id: 'barmitzvah', title: 'בר/בת מצווה', sub: 'גיל 12-13', icon: <Icon.Star size={22} /> },
    { id: 'wedding', title: 'חתונה', sub: 'יום מיוחד', icon: <Icon.Rings size={22} /> },
    { id: 'birthday', title: 'יום הולדת', sub: 'כל גיל', icon: <Icon.Cake size={22} /> },
    { id: 'anniversary', title: 'יום נישואין', sub: 'אבני דרך', icon: <Icon.Heart size={22} /> },
    { id: 'family', title: 'אירוע משפחתי', sub: 'כל סוג', icon: <Icon.Crown size={22} /> },
    { id: 'other', title: 'אחר', sub: 'התאמה אישית', icon: <Icon.Calendar size={22} /> },
  ];

  return (
    <div className="screen">
      <div className="screen-header">
        <button className="icon-btn" onClick={onBack} aria-label="חזרה">
          <Icon.ChevronRight size={20} />
        </button>
        <div className="step-counter">שלב 1 מתוך 5</div>
        <div style={{ width: 38 }} />
      </div>
      <div className="screen-scroll">
        <div className="eyebrow" style={{ marginTop: 24 }}>
          נתחיל מהבסיס
        </div>
        <h1 className="h1">
          לאיזה אירוע
          <br />
          מכינים סרטון?
        </h1>
        <p className="lede">נתאים את הסגנון, הקצב והנרטיב לאירוע שלכם.</p>

        <div className="event-grid">
          {events.map((e) => (
            <div
              key={e.id}
              className={'event-card' + (value === e.id ? ' is-selected' : '')}
              onClick={() => onChange(e.id)}
            >
              <div className="glyph">{e.icon}</div>
              <div>
                <div className="title">{e.title}</div>
                <div className="sub">{e.sub}</div>
              </div>
              {value === e.id && (
                <div
                  style={{
                    position: 'absolute',
                    top: 12,
                    left: 12,
                    width: 22,
                    height: 22,
                    borderRadius: 999,
                    background: 'var(--accent)',
                    color: 'white',
                    display: 'grid',
                    placeItems: 'center',
                  }}
                >
                  <Icon.Check size={12} />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      <div className="cta-dock">
        <button className="btn-primary" disabled={!value} onClick={onNext}>
          המשך
          <Icon.ArrowLeft size={18} />
        </button>
      </div>
    </div>
  );
}
